export default __webpack_public_path__ + "static/media/carson-project-4.95996fd4.jpg";